import React, { createRef } from 'react'
import {
    Form,
    Input,
    NavBar,
    Button,Dialog,Popup,
    Toast
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { FillinOutline,StarOutline,StarFill,AppOutline } from 'antd-mobile-icons'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import '../AIChat/index.css'

import {
    GetMediaFile, CreateWxConfig, GetWXJSSDK, PostRecordingDetails, SaveRecordingDetails,
    UpdateRecordingDetailById, DelRecordingDetailById, SaveUserAction
} from '../../service/service';
import { environment } from '../../service/baseUrl';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

// ======================
// 你已有的插件：直接用
// ======================
import { ChatFeed, Message } from 'react-chat-ui'; // 你已安装
// const abpSignalr = window.abp.signalr; // 你已引入 script
const signalr = window.signalR;


// 路由包装
const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

// ======================
// 主页面
// ======================
class Index extends React.Component {
    formRef = createRef();
    connection = null; // signalr 连接

    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            openid:"",
            userInfo: {},
            messages: [], // 消息
            inputText: "",
            isTyping: false,
            hasHistory: false, // 是否有历史记录
            connectionStatus: "已连接", // 连接状态
        };
    }

    componentDidMount() {
        {
            const script = document.createElement('script');
            script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";
            script.async = true;
            document.body.appendChild(script);
        }
        // {
        //     const script = document.createElement('script');
        //     script.src = "https://niannian.weibinyi.com/signalr.min.js";
        //     script.async = true;
        //     document.body.appendChild(script);
        // }

        // 路由ID
        const { location } = this.props;
        const { id } = location.state || {};
        if (id) {
            var openid = localStorage.getItem("openid");
            this.setState({ id, openid });

        }

        // 用户信息
        const user = localStorage.getItem("user");
        if (user) {
            this.setState({ userInfo: JSON.parse(user) });
        }

        // this.initSignalR();
    }

    // ==============================================
    // 【初始化】加载历史聊天记录
    // ==============================================
    initHistoryMessages = () => {
        if (!this.connection || this.connection.state !== signalr.HubConnectionState.Connected) {
            Toast.show("连接已断开，正在重连，请稍候...");
            this.setState({
                connectionStatus: "断开连接，正在重连...",
                isTyping: false
            });

            // 🔥 旧版兜底：自动重试连接
            setTimeout(() => {
                this.initSignalR();
            }, 3000);
            return;
        }

        this.setState({ isTyping: true });

        // const { location } = this.props;
        // const { id } = location.state || {};
        // var openid = localStorage.getItem("openid");

        // 调用后端
        this.connection.invoke("SummarizeHistory", this.state.openid, parseInt(this.state.id))
            .catch(err => {
                debugger
                console.error(err);
                this.setState({ isTyping: false });
            });

        // // 模拟接口请求 800ms
        // setTimeout(() => {
        //     // 模拟：是否有历史聊天
        //     const hasHistory = false; // 测试时改成 true 看历史效果

        //     if (hasHistory) {
        //         // 有历史
        //         this.setState({
        //             messages: [
        //                 new Message({ id: 0, message: "你好，我之前问过问题" }),
        //                 new Message({ id: 1, message: "记得的，你请说～" }),
        //             ],
        //             hasHistory: true
        //         }, this.scrollToBottom);
        //     } else {
        //         // 无历史 → 显示欢迎语
        //         this.setState({
        //             messages: [
        //                 new Message({ id: 1, message: "你好！我是 AI 助手，有什么可以帮你的？" })
        //             ]
        //         }, this.scrollToBottom);
        //     }
        // }, 800);
    };

    // ==============================================
    // 【测试用】模拟 SignalR 流式回复
    // ==============================================
    sendMessageMockSignalR = (userText) => {
        this.setState({ isTyping: true });

        // AI 回复内容
        const aiReply = "这是模拟 SignalR 流式返回的消息，逐字输出效果，测试完全正常！";
        let currentText = "";

        // 先追加空消息
        this.setState(prev => ({
            messages: [...prev.messages, new Message({ id: 1, message: "" })]
        }));

        // 逐字输出
        const timer = setInterval(() => {
            if (currentText.length >= aiReply.length) {
                clearInterval(timer);
                this.setState({ isTyping: false });
                return;
            }
            currentText = aiReply.slice(0, currentText.length + 1);

            this.setState(prev => {
                const newMsgs = [...prev.messages];
                newMsgs[newMsgs.length - 1].message = currentText;
                return { messages: newMsgs };
            }, this.scrollToBottom);
        }, 50);
    };

    // ==============================================
    // 【上线用】真实 SignalR 发送
    // ==============================================
    sendMessageRealSignalR = (userText) => {
        if (!this.connection || this.connection.state !== signalr.HubConnectionState.Connected) {
            Toast.show("连接已断开，正在重连，请稍候...");
            this.setState({
                connectionStatus: "断开连接，正在重连...",
                isTyping: false
            });

            // 🔥 旧版兜底：自动重试连接
            setTimeout(() => {
                this.initSignalR();
            }, 3000);
            return;
        }

        this.setState({ isTyping: true });

        // 调用后端
        this.connection.invoke("SendMessage", userText, this.state.openid, parseInt(this.state.id))
            .catch(err => {
                debugger
                console.error(err);
                this.setState({ isTyping: false });
            });
    };

    initSignalR = () => {
        try {
            var that = this;

            // 旧版 SignalR 不支持链式 withAutomaticReconnect，所以分开写
            const builder = new signalr.HubConnectionBuilder();
            builder.withUrl(environment.apiEndpoint + "/aiChatHub");
    
            // 🔥 兼容旧版：手动配置重连
            if (builder.withAutomaticReconnect) {
                builder.withAutomaticReconnect([0, 2000, 5000, 10000, 30000]);
            }
    
            this.connection = builder.build();

            // 接收后端流式消息
            this.connection.on("ReceiveMessage", (fixedText, realText) => {
                this.setState(prev => {
                    const msgs = [...prev.messages];
                    const last = msgs[msgs.length - 1];
                    if (last && last.id === 1) {
                        last.message += realText; // ✅ 用第二个参数！
                    } else {
                        msgs.push(new Message({ 
                            id: 1, 
                            message: realText,
                            senderName: that.state.userInfo.nickName,
                        }));
                    }
                    return { messages: msgs };
                }, this.scrollToBottom);
            });
            
            // 接收后端流式消息
            this.connection.on("CloseTyping", () => {
                this.setState({ isTyping: false });
            });

            // ==============================================
            // 🔥 重连监听（旧版也支持）
            // ==============================================
            this.connection.onreconnecting = () => {
                debugger
                console.log("连接断开，正在重连...");
                this.setState({
                    connectionStatus: "断开连接，正在重连...",
                    isTyping: false
                });
                Toast.show("网络已断开，正在自动重连...");
            };

            this.connection.onreconnected = () => {
                debugger
                console.log("重连成功！");
                this.setState({
                    connectionStatus: "已连接",
                });
                Toast.show("网络已恢复");
            };

            this.connection.onclose = (error) => {
                debugger
                console.error("连接已关闭", error);
                this.setState({
                    connectionStatus: "连接已断开，刷新重连",
                    isTyping: false
                });
                Toast.show("连接已断开，正在尝试重新连接...");

                // 🔥 旧版兜底：自动重试连接
                setTimeout(() => {
                    this.initSignalR();
                }, 3000);
            };

            // 启动连接
            this.connection.start()
                .then(() => {
                    console.log("✅ SignalR 连接成功");
                    this.setState({ connectionStatus: "已连接" });
                    this.initHistoryMessages();
                })
                .catch(err => {
                    console.error("❌ 连接失败：", err);
                    Toast.show("连接失败，3秒后重试");

                    // 失败自动重连
                    setTimeout(() => {
                        this.initSignalR();
                    }, 3000);
                });

        } catch (err) {
            console.error("❌ SignalR 连接失败：", err);
        }
    };

    // ==============================================
    // 发送消息（你测试时 → 用 mock 版）
    // ==============================================
    handleSend = () => {
        const { inputText, messages, userInfo } = this.state;
        if (!inputText.trim()) return;

        // 加入用户消息
        const userMsg = new Message({ 
            id: 0, 
            senderName: userInfo.nickName,
            message: inputText 
        });

        this.setState({
            messages: [...messages, userMsg],
            inputText: ""
        }, () => {
            this.scrollToBottom();

            // // ======================
            // // 你现在测试：用模拟版
            // // ======================
            // this.sendMessageMockSignalR(inputText);

            // 以后上线：打开这个，注释上面那行
            this.sendMessageRealSignalR(inputText);
        });
    };

    // 自动滚动到底部
    scrollToBottom = () => {
        const box = document.getElementById("chat-box");
        if (box) box.scrollTop = box.scrollHeight;
    };

    render() {
        const { messages, inputText, isTyping, id, connectionStatus } = this.state;

        // 限制最多200字符
        const maxLength = 200;
        const currentLength = inputText.length;
        const isMax = currentLength >= maxLength;

        return (
            <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
                <NavBar
                    back='返回'
                    onBack={() => {
                        this.props.navigate('/home?planetId=' + id, {
                            replace: true, state: { id }
                        });
                    }}
                    style={{
                        borderBottom: '1px solid #eee',
                        height: '6%',
                        backgroundColor: '#fff',
                        fontWeight: 500
                    }}
                    right={<>
                        <FillinOutline fontSize="20px" style={{ marginTop: "5px" }}
                            color='var(--adm-color-primary)' onClick={() => {

                                Dialog.show({
                                    title: '',
                                    content: (
                                        
                    <div className='aichat' style={{ backgroundColor: "#fff", width: "92%", marginLeft: "4%", overflowY: "scroll", height: "98%" }}>
                        <Form
                            name='form'
                            ref={this.formRef}
                            footer={
                                <div>
                                    <div style={{
                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/13-09.png')"
                                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                        , textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                        , fontWeight: "600", color: "#fff"
                                    }} onClick={() => {
                                        this.submitForm();
                                    }}>
                                        提 交
                                    </div>
                                </div>
                            }
                        >
                            <Form.Item name='FamilyRelationName' label="请问您如何称呼" rules={[{ required: true }]}>
                                <Input placeholder='请输入您的称呼' style={{ marginLeft: "10px" }} />
                            </Form.Item>
                            
                            {/* <Form.Item name='FamilyRelationOne' label="请问您与逝者的关系为">
                                <div onClick={() => {
                                    this.setState({
                                        visibleOne: true
                                    })
                                }}>
                                    <span style={{ fontSize: "14px", marginLeft: "3%" }}>{this.state.textPickerOne}</span>
                                    <span style={{ float: "right" }}>
                                        <RightOutline />
                                    </span>
                                </div>

                                <Picker
                                    columns={this.state.pickerOne}
                                    visible={this.state.visibleOne}
                                    onClose={() => {
                                        this.setState({
                                            visibleOne: false
                                        })
                                    }}
                                    value={[this.state.valuePickerOne]}
                                    onConfirm={(v) => {
                                        var value = v[0];
                                        var item = this.state.pickerOne[0].filter(x => x.value == value)
                                        this.setState({
                                            valuePickerOne: value,
                                            textPickerOne: item[0].label
                                        })
                                    }}
                                />
                            </Form.Item>

                            <div className="DeadDate">
                                <Form.Item name='TypeId' label="回忆类型" rules={[{ required: true }]}>
                                    <div onClick={() => {
                                        this.setState({
                                            visible: true
                                        })
                                    }}>
                                        <span style={{ fontSize: "14px", marginLeft: "3%" }}>{this.state.textPicker}</span>
                                        <span style={{ float: "right" }}><RightOutline /></span>
                                    </div>

                                    <Picker
                                        columns={this.state.pickers}
                                        visible={this.state.visible}
                                        onClose={() => {
                                            this.setState({
                                                visible: false
                                            })
                                        }}
                                        value={[this.state.valuePicker]}
                                        onConfirm={(v) => {
                                            var value = v[0];
                                            var item = this.state.pickers[0].filter(x => x.value == value)
                                            this.setState({
                                                valuePicker: value,
                                                textPicker: item[0].label
                                            })
                                            this.formRef.current.setFieldsValue({ TypeId: value });
                                        }}
                                    />
                                </Form.Item>
                            </div> */}


                        </Form>
                    </div>

                                    ),
                                    closeOnMaskClick: true,
                                    // 只保留一个关闭按钮
                                    actions: []
                                });

                            }} />
                    </>}
                >
                    AI对话 | {connectionStatus}
                </NavBar>

                {/* 聊天区域优化 */}
                <div
                    id="chat-box"
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        backgroundColor: '#f5f7fa',
                        padding: '12px 10px',
                    }}
                >
                    <ChatFeed
                        messages={messages}
                        isTyping={isTyping}
                        showSenderName={true}
                        bubbleStyles={{
                            userBubble: {
                                backgroundColor: '#007aff',
                                color: '#fff',
                                borderRadius: 16,
                                padding: '8px 12px',
                                fontSize: 15,
                            },
                            chatBubble: {
                                backgroundColor: '#fff',
                                color: '#333',
                                borderRadius: 16,
                                padding: '8px 12px',
                                fontSize: 15,
                                boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                            },
                        }}
                    />
                </div>

                <div style={{
                    padding: '10px',
                    backgroundColor: '#fff',
                    borderTop: '1px solid #eee',
                    display: 'flex',
                    alignItems: 'flex-end',
                    position: 'relative'
                }}>
                    {/* 自适应高度文本域 */}
                    <textarea
                        value={inputText}
                        maxLength={200}
                        onChange={(e) => {
                            const val = e.target.value;
                            if (val.length <= 200) {
                                this.setState({ inputText: val });
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                this.handleSend();
                            }
                        }}
                        rows={1}
                        placeholder="输入消息..."
                        style={{
                            flex: 1,
                            marginRight: '8px',
                            borderRadius: '20px',
                            backgroundColor: '#f5f7fa',
                            padding: '10px 14px',
                            fontSize: '15px',
                            border: 'none',
                            outline: 'none',
                            resize: 'none',
                            minHeight: '40px',
                            maxHeight: '80px',
                            lineHeight: '20px',
                            overflowY: 'auto',
                            boxSizing: 'border-box',
                        }}
                    />

                    {/* 字数统计 */}
                    <span style={{
                        position: 'absolute',
                        right: '70px',
                        bottom: '12px',
                        fontSize: '12px',
                        marginRight:"15px",
                        color: inputText.length >= 200 ? '#ff3333' : '#999'
                    }}>
                        {inputText.length}/200
    </span>

                    {/* 发送按钮 */}
                    <Button
                        color="primary"
                        onClick={this.handleSend}
                        disabled={!inputText.trim() || inputText.length >= 200}
                        style={{
                            borderRadius: '20px',
                            height: '40px',
                            padding: '0 14px'
                        }}
                    >
                        发送
    </Button>
                </div>



            </div>
        );
    }
}

export default withNavigate(Index);